
/// <reference path="businessinfo.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../components/commonClasses/commonControllerBase.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.BusinessInfo {
    class BusinessInfoController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "meevo.components.common.ImageGalleryService",
            "$mdToast",
            "$translate",
            "meevo.components.common.BusinessInfoDataService",
        ];

        public issingleLocation: boolean = false;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.BusinessInfoDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            protected $mdToast: angular.material.IToastService,
            protected $translate: angular.translate.ITranslateService,
            protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();

            if (this.identityService.current().isSingleLocation) {
                this.issingleLocation = true;
            }
        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.DATA_BUSINESSINFO).then(() => {
                this.busyService.stop();
                this.context = new BusinessInfoContext(this, this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.imageGalleryService, this.busyService, this.$rootScope, this.$mdToast, this.$translate);
                super.createContext();

                this.context.postUpdate = (model: any) => {
                    let businfoModel = <Meevo.Model.BusinessInfo>model;
                    this.context.headerContent = businfoModel.storeName;
                    this.$rootScope.$broadcast("updateRegisterSetting", { enableIntegratedRegister: model.enableIntegratedRegister });
                    if (Model.Guard.isSomething(this.context.closeCallback)) {
                        this.context.closeCallback(model, true);
                    }
                    this.businessInfoDataService.getBusinessInfoPreferences({force: true});
                }
            });
        }


        viewAuditDetail(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/businessInfo/sectionViews/view.taxHistory.html",
                controller: "TaxAuditLog",
                controllerAs: "context",
                bindToController: true
            }

            this.modalService.showCustom(options);
        }
    }

    angular.module("meevo.plugins.businessInfo")
        .controller("meevo.plugins.businessInfo.BusinessInfoController", BusinessInfoController);
}